<template>
  <div>
    <div class="dialog-title" :class="{'header-title-box-margin': formTabsOptions.length > 1}">
      <div class="header-title">
        <span>自定义列</span>
        <div v-if="formTabsOptions.length > 1" class="separate"></div>
        <Tabs v-if="formTabsOptions.length > 1" class="tabs-box" v-model="formTabsId" :tabs="formTabsOptions" :fontSize="13" />
      </div>
      <i class="iconhuice icon-guanbi" @click="handleClickCancel" />
    </div>
    <div class="dialog-body">
      <CustomColumn
        v-show="item.id === formTabsId"
        v-for="item in customColumnOptionsValues"
        :key="item.id"
        :ref="`customColumn${item.id}`"
        :customColumn="item"
      />
    </div>
    <div class="dialog-footer">
      <div style="flex: 1;">
        <el-button v-outFocus plain @click="handleClickRecover">恢复默认</el-button>
      </div>
      <el-button v-outFocus plain @click="handleClickCancel">取消</el-button>
      <el-button v-outFocus type="primary" @click="handleClickDone">确定</el-button>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/tabs'
import CustomColumn from './customColumn'
import { isNullOrUndefinedOrEmptyStr } from '@/services/utils/modules/base'
export default {
  components: {
    Tabs,
    CustomColumn
  },
  props: {
    customColumn: {
      type: Object,
      default() {
        return {}
      }
    },
    // 目前使用的 columns
    activeColumns: {
      type: Array,
    },
  },
  data() {
    return {
      formTabsOptions: [],
      formTabsId: '',
      customColumnOptionsValues: []
    }
  },
  created() {
    const formTabsOptions = []
    this.customColumnOptionsValues = Object.values(this.customColumn.options)
    this.customColumnOptionsValues.forEach((item, index) => {
      // 如果用户没有提供id, 使用index作为id
      if (isNullOrUndefinedOrEmptyStr(item.id)) {
        item.id = index
      }

      formTabsOptions.push({
        id: item.id,
        name: item.name,
      })
    })
    this.formTabsOptions = formTabsOptions

    this.initDefaultActiveTabId() // 计算 created 显示的 tabId
  },
  methods: {
    initDefaultActiveTabId() {
      if (!isNullOrUndefinedOrEmptyStr(this.customColumn.defaultActiveTabId)) {
      // 提供了 defaultActiveTabId
        this.formTabsId = this.customColumn.defaultActiveTabId
        return
      }

      if (this.activeColumns) {
        // 存在 activeColumns, 且 !== undefined
        // 使用 tableConfig.props.columns 和 tableConfig.customColumn.options[xxx].editColumns 比较，确定 activeTabId
        const findItem = Object.values(this.customColumn.options).find(option => option.editColumns === this.activeColumns)
        if (findItem) {
          this.formTabsId = findItem.id
          return
        }
      }

      // 默认使用第0个，作为 activeTabId
      this.formTabsId = this.formTabsOptions[0].id
    },
    handleClickCancel() { // 取消
      this.$emit('cancel')
    },
    async handleClickDone() { // 保存
      this.$emit('loading', true)
      const arr = []
      for (let i = 0; i < this.customColumnOptionsValues.length; i++) {
        const option = this.customColumnOptionsValues[i]
        const res = await this.$refs[`customColumn${option.id}`][0].updateData()
        if (!res) {
          this.$emit('loading', false)
          return
        }
        arr.push(res)
      }
      this.$emit('done', arr)
      this.$emit('loading', false)
    },
    handleClickRecover() { // 恢复默认
      this.$refs[`customColumn${this.formTabsId}`][0].reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.header-title{
  display: flex;
  align-items: center;
  .separate{
    width: 1px;
    height: 14px;
    box-shadow: inset 1px 0px 0px 0px #706F80;
    margin-left: 12px;
  }
  .tabs-box{
    font-size: 13px;
  }
}
.header-title-box-margin{
  margin-top: -10px;
  padding-bottom: 0 !important;
  // border-bottom: 1px solid #F0F0F0;
}
</style>
